module.exports = __webpack_public_path__ + "static/media/decorate-image.8a7ef2a1.png";